module.exports = __webpack_public_path__ + "img/31.95f8b675.jpg";